/* GPI product gallery — swipe (touch) + drag (mouse) + desktop arrow buttons
   + arrow keys. Base theme only supported tapping thumbnails. */
(function () {
  function init() {
    var main = document.getElementById('gpi-main-img');
    var thumbs = [].slice.call(document.querySelectorAll('.gpi-thumb'));
    if (!main || thumbs.length < 2) return;
    var srcs = thumbs.map(function (t) { return t.getAttribute('data-src'); });
    var idx = 0;
    for (var k = 0; k < thumbs.length; k++) { if (thumbs[k].classList.contains('active')) { idx = k; break; } }

    function show(i) {
      idx = (i + srcs.length) % srcs.length;
      if (srcs[idx]) main.src = srcs[idx];
      thumbs.forEach(function (t, j) { t.classList.toggle('active', j === idx); });
      var at = thumbs[idx];
      if (at && at.scrollIntoView) { try { at.scrollIntoView({ inline: 'center', block: 'nearest' }); } catch (e) {} }
    }

    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { idx = j; }); });

    var wrap = main.closest('.gpi-gallery') || main.parentElement;
    if (!wrap) return;
    wrap.style.touchAction = 'pan-y';

    /* desktop prev/next arrows */
    function makeArrow(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'gpi-gal-arrow gpi-gal-arrow--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', dir < 0 ? 'Previous image' : 'Next image');
      b.innerHTML = dir < 0
        ? '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>'
        : '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>';
      b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(idx + dir); });
      return b;
    }
    wrap.appendChild(makeArrow(-1));
    wrap.appendChild(makeArrow(1));

    /* touch swipe */
    var x0 = null, y0 = null;
    wrap.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; y0 = e.changedTouches[0].clientY; }, { passive: true });
    wrap.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { show(idx + (dx < 0 ? 1 : -1)); }
    }, { passive: true });

    /* mouse drag (desktop) */
    var mx = null;
    wrap.addEventListener('mousedown', function (e) { mx = e.clientX; });
    window.addEventListener('mouseup', function (e) {
      if (mx === null) return;
      var dx = e.clientX - mx; mx = null;
      if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1));
    });

    /* keyboard arrows */
    wrap.setAttribute('tabindex', '0');
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(idx + 1);
      else if (e.key === 'ArrowLeft') show(idx - 1);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
}());
